
import { Injectable, Inject} from '@angular/core';
import {BaseDO} from './base.model';


 export  class BulkProcessDetailDO extends BaseDO {

    public id:Number;
    public  proposalNum:string= null;
    public  reconcileStatusCd:string= null;
    public  productCd:string= null;

    public  productVersion:string= null;
    public  statusCd:string= null;
    public  stageCd:string= null;
    public  uwDecisionCd:string= null;
    public  coResponseCd:string= null;
    public  sumInsured:Number= null;
    public  finalPremiumAmt:Number= null;

    
 }